import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import LTTPodcastNavbarmenu from "../PodCastFolder/LTTPodcastNavbarmenu";
import PodcastSideNavbar from "../PodCastFolder/PodcastSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LibraryContent.css";

function LibraryContent() {
  return (
    <>
      <div className="podcast-sidenavbar-holder">
        <PodcastSideNavbar />
      </div>
      <div className="navbar-holder podcast-navbar-holder">
        <LTTPodcastNavbarmenu />
      </div>
      <div className="podcast-banner-container">
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/LTT-Podcast"
            >
              L&TT Podcast
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Library"
            >
              Library
            </NavLink>
          </li>
        </ul>
      </div>
      <h2 className="under-construction">Under Construction</h2>
    </>
  );
}

export default LibraryContent;
